import { render, staticRenderFns } from "./educationCourse.vue?vue&type=template&id=0f56e4e8"
import script from "./educationCourse.vue?vue&type=script&lang=js"
export * from "./educationCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f56e4e8')) {
      api.createRecord('0f56e4e8', component.options)
    } else {
      api.reload('0f56e4e8', component.options)
    }
    module.hot.accept("./educationCourse.vue?vue&type=template&id=0f56e4e8", function () {
      api.rerender('0f56e4e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/edu/cc/educationCourse.vue"
export default component.exports